export const marketplaces = [
  { name: "Mercado Livre", src: "/images/marketplaces-logos/ml.png" },
  { name: "Shopee", src: "/images/marketplaces-logos/shopee.png" },
  { name: "Shein", src: "/images/marketplaces-logos/shein.svg" },
  { name: "Magalu", src: "/images/marketplaces-logos/magalu.svg" },
  { name: "Amazon", src: "/images/marketplaces-logos/amazon.svg" },
  { name: "TikTok Shop", src: "/images/marketplaces-logos/tiktok.svg" },
];
